import React from 'react';
import './Home.css';
import HomeCategory from './HomeCategory';
import HomeCompany from './HomeCompany';
import HomeVideo from './HomeVideo';
import HomeApp from './HomeApp';

const Home = () => {
  return (
    <div className="home">
      <div className="home-title">
        1F 特种塑料应用分类
      </div>
      <div className="red-line"></div>
      <HomeCategory />
      <div className="home-title">
        2F 企业品牌说
      </div>
      <div className="red-line"></div>
      <HomeCompany />
      <HomeVideo />
      <HomeApp />
    </div>
  );
};

export default Home;